import AbstractRequestTask from "../AbstractRequestTask";
import device from "../../../devices/device";
import Utils from '../../../utils/Utils';
import Launcher from '../../apa/Launcher';
import {ENABLE_MODAL_RETRIES} from '../../RequestManagerConstants';


class LoginNETTask extends AbstractRequestTask {
    constructor(params = {}) {
        super();
        this.ownParams = params;
    }

    getParams() {
        return this.ownParams;
    }

    getMethod() {
        return 'POST';
    }

    getHeaders() {
       return null;
    }

    getEncType() {
        return 'multipart/form-data';
    }

    getUrl() {
      const http = "https://";
      const url = Launcher.get("akamai_mfwk");

      return `${http}${url}/services/user/net/auth?${Utils.buildQueryParams(super.getParams())}`;
    }

    getShowErrorModal(){
        return ENABLE_MODAL_RETRIES;
    }

}

export default LoginNETTask;



// WEBPACK FOOTER //
// ./src/requests/tasks/user/LoginNETTask.js